import axios from 'axios';


export const getVideoUrlAsync = async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    try {
        const response = await axios.get(`${baseUrl}/video-url`);
        return response.data;
    } catch (error: any) {
        if (error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
    
};
